import React from "react";

const CoffeeButton = () => (
  <div>
    <a href="https://paypal.me/brandontwilliams5393?locale.x=en_US">
      <img
        className="coffee-img"
        src="/Buymeacoffeeimagetransparent.png"
        alt="Like my app? Buy me a coffee."
      />
    </a>
  </div>
);

export default CoffeeButton;
